"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateCell = exports.DateCellDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var date_calendar_1 = require("../elements/date-calendar");
exports.DateCellDefaultProps = {
  emptyValue: '–',
  relative: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n  "], ["\n    display: flex;\n    flex-direction: row;\n  "])))
});
var EmptyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme_1.theme.COLOR('text-subtle'))
});
var DateStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(15))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Empty: styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), EmptyStyles),
  Date: (0, styled_components_1.default)(date_calendar_1.DateCalendar)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), DateStyles)
};
var DateCell = function (props) {
  var className = props.className,
    value = props.value,
    emptyValue = props.emptyValue,
    relative = props.relative,
    showTime = props.showTime;
  var toFormat = showTime ? "Do MMM YYYY H:mm a" : 'Do MMM YYYY';
  var fromFormat = showTime ? 'YYYY-MM-DDTHH:mm' : 'YYYY-MM-DD';
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Date, {
    showTime: showTime,
    date: value
  }));
};
exports.DateCell = DateCell;
exports.DateCell.defaultProps = exports.DateCellDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;